<div class="admin-maintenance-banner" *ngIf="showBanner">
  <div class="banner-content">
    <div class="banner-icon">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4zM6.7 8.8c-.7.7-1.9.7-2.6 0-.7-.7-.7-1.9 0-2.6.7-.7 1.9-.7 2.6 0 .7.7.7 1.9 0 2.6z" fill="currentColor"/>
      </svg>
    </div>
    <div class="banner-text">
      <strong>Admin-Hinweis:</strong> Wartung ist aktiv - {{ displayMessage }}
      <span class="banner-timestamp" *ngIf="updatedAt">(seit {{ updatedAt }})</span>
    </div>
    <button class="banner-close" (click)="closeBanner()" title="Banner schließen">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>